/**
 * @author Tomas Frinta
 * @version 
 * 1.00 (9.4.2019)
 * 1.01 (18.12.2019)
 * - pridana metoda createItems()
 */

export class Pool<T> {
    private _itemType: { new(): T; };
    private _itemCreateClb: () => T;
    private _itemCreateClbCtx: any;

    private _pool: T[];

    /**
    * (RO) Aktualni pocet polozek v poolu
    */
    get size(): number { return this._size; }
    private _size: number;

    /**
    * (RO) True, pokud se pool muze zvetsovat pocet polozek nad ramec vychoziho poctu zadaneho v konstruktoru
    */
    get canGrow(): boolean { return this._canGrow; }
    private _canGrow: boolean;

    /**
    * (RO) Celkovy pocet alokovanych polozek
    */
    get allocatedItemCnt(): number { return this._allocItemCnt; }
    private _allocItemCnt: number;

    //-------------------------------------------------------------------------
    /**
     * Konstruktor
     * @param itemType Typ polozky, pokud jeji konstruktor nepotrebuje parametry. Jinak null nebo undefined a polozka se bude vytvaret pres callback.
     * @param defSize Vychozi velikost poolu. Default = 0.
     * @param canGrow True, pokud se buffer poolu muze zvetsovat. Default = true.
     * @param itemCreateClb Callback pro vytvoreni nove polozky poolu. Default = null.
     * @param itemCreateClbCtx Context pro callback. Default = undefined
     */
    //-------------------------------------------------------------------------
    constructor(itemType: { new(): T; }, defSize: number = 0, canGrow: boolean = true, itemCreateClb?: () => T, itemCreateClbCtx?: any) {
        this._itemType = itemType;
        this._itemCreateClb = itemCreateClb;
        this._itemCreateClbCtx = itemCreateClbCtx;

        this._canGrow = canGrow;
        this._pool = [];

        while (defSize-- != 0)
            this._pool.push(this.newItem());

        this._size = this._pool.length;
        this._allocItemCnt = this._size;
    }

    //-------------------------------------------------------------------------
    /**
     * Vytvori pozadovany pocet polozek v poolu. Ignoruje "canGrouw".
     * @param cnt Pocet polozek, ktere chceme pridat do poolu
     */
    //-------------------------------------------------------------------------
    createItems(cnt: number): Pool<T> {
        while (cnt-- != 0) {
            this._pool.push(this.newItem());
            this._size++;
        }

        return this;
    }

    //-------------------------------------------------------------------------
    /**
     * Ziskani polozky z poolu
     */
    //-------------------------------------------------------------------------
    getItem(): T {
        if (this._size == 0) {
            return (this._canGrow ? this.newItem() : undefined);
        }
        else {
            let item = this._pool[--this._size];
            this._pool[this._size] = undefined;

            return item;
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Vraceni polozky do poolu
     * @param item
     * @returns Polozka vracena do poolu
     */
    //-------------------------------------------------------------------------
    returnItem(item: T): T {
        this._pool[this._size++] = item;
        return item;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected newItem(): T {
        this._allocItemCnt++;

        if (this._itemCreateClb) {
            return this._itemCreateClb.call(this._itemCreateClbCtx, this._size);
        }
        else {
            return new this._itemType();
        }
    }
}